
<router-outlet></router-outlet>
<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.7)"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
  <div class="loading-container">
    <div class="loading-text">
      {{ loadingService.title$ | async }}
      <span class="dots"></span>
    </div>

    <div class="loading-subtext">
      {{ loadingService.message$ | async }}
    </div>
  </div>
</ngx-spinner>

<router-outlet></router-outlet>
